export default {
  /**
   * Request a phone OTP
   * @param {Object} store - Vuex store
   * @param {String} phoneNumber - The phone number to send OTP to
   * @returns {Promise} - Response from the API
   */
  async requestPhoneOTP(store, phoneNumber) {
    try {
      const response = await store.dispatch("user/requestPhoneOTP", {
        phone_number: phoneNumber,
      });
      return response;
    } catch (error) {
      console.error("Error requesting phone OTP:", error);
      throw error;
    }
  },

  /**
   * Request an email OTP
   * @param {Object} store - Vuex store
   * @param {String} email - The email to send OTP to
   * @returns {Promise} - Response from the API
   */
  async requestEmailOTP(store, email) {
    try {
      const response = await store.dispatch("user/requestEmailOTP", {
        email: email,
      });
      return response;
    } catch (error) {
      console.error("Error requesting email OTP:", error);
      throw error;
    }
  },
};
